import { HStack } from "@repo/components/src/ui/hstack";
import { Icon } from "@repo/components/src/ui/icon";
import { Pressable } from "@repo/components/src/ui/pressable";
import { Toast, ToastDescription } from "@repo/components/src/ui/toast";
import * as Clipboard from "expo-clipboard";
import { Copy } from "lucide-react-native";
import React, { ComponentProps, useCallback } from "react";
import MontuToastProvider from "../../../globalProviders/toast";

type Props = {
  copyContent?: string | undefined;
  children?: React.ReactNode;
  iconProps?: ComponentProps<typeof Icon>;
  hideIconOnHover?: boolean;
  copyMessage: string;
  toastProps?: ComponentProps<typeof Toast>;
};

const CopyButton = React.memo((props: Props) => {
  const {
    copyContent,
    iconProps,
    children,
    hideIconOnHover = false,
    copyMessage,
    toastProps = {
      variant: "solid",
      action: "success",
    },
  } = props;
  const onPress = useCallback(async () => {
    if (!copyContent) return;
    await Clipboard.setStringAsync(copyContent);
    MontuToastProvider.show({
      placement: "bottom",
      duration: 2000,
      render: ({ id }) => (
        <Toast nativeID={`toast-${id}`} {...toastProps}>
          <ToastDescription size="sm">{copyMessage}</ToastDescription>
        </Toast>
      ),
    });
  }, [copyContent, copyMessage, toastProps]);
  return (
    <Pressable onPress={onPress} disabled={!copyContent}>
      {() => {
        return (
          <HStack space="sm" className="items-center group/copy-button">
            {children}
            <Icon
              as={Copy}
              {...iconProps}
              className={
                hideIconOnHover
                  ? `group-hover/copy-button:block hidden ${iconProps?.className}`
                  : iconProps?.className
              }
            />
          </HStack>
        );
      }}
    </Pressable>
  );
});

CopyButton.displayName = "CopyButton";

export default CopyButton;
